module.exports = __webpack_public_path__ + "static/media/uni-logo.80c3d16b.svg";